// Design tokens for the CallerV2 "Caller ID" panel (Figma node 19:1066).
// Single source of colors so the styled-components stay readable and consistent.
export const CALLER_COLORS = {
  navy: '#001848', // primary text (title, name)
  gray: '#6b7280', // secondary text (phone, subtitle, chips)
  green: '#0e7f19', // incoming-call text + badge text
  greenBtn: '#13b023', // BOOK button background
  greenBtnBorder: '#0e9e1f', // BOOK button border
  badgeBg: '#dcf3df', // "name available" badge background
  iconTintBg: 'rgba(19,176,35,0.12)', // header phone-icon tinted square
  orange: '#b26a00', // rebook-due emphasis
  red: '#c5283d', // no-show warning
  border: '#e5e8ef', // card / divider / header borders
  lightBtnBg: '#f2f4f8', // close button + "See more" / "Collapse" chips
  panelBg: '#f7f8fb', // scrollable list background
  cardShadow: '0px 2px 3px rgba(0,24,72,0.06)', // card drop shadow
  // Caller Detail panel (Figma node 19:4515)
  accentOrange: '#fb4e00', // Re Book, service chips, Add-services, note bullets
  orangeSoftBg: '#fff5ec', // Re Book / service chip background
  avatarBg: '#ffead9', // customer avatar circle
  slate: '#2c334b', // composer sublabels (Staff / Start time / Services), See more
  placeholder: '#9aa3b2', // empty note placeholder text
  dashedBorder: '#d6dbe3', // dashed note input border
} as const;
